<template>
  <svg
    width="18px"
    height="18px"
    fill="none"
    stroke="currentColor"
    stroke-width="1.4"
    data-stroke="non-scaling"
    viewBox="0 0 16 16"
  >
    <path
      d="M14.667 14.667l-3.438-3.437m1.699-4.1a5.797 5.797 0 11-11.595 0 5.797 5.797 0 0111.595 0z"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
